export default "__VITE_ASSET__CbZnvzN6__"